export default "/static/cytation_tiny.png";